import React, { useEffect, useState, useContext } from 'react';
import PlantList from './PlantList';
import PlantCategoryList from './PlantCategoryList';
import LocationList from './LocationList';

function Admin() {
    const [activeTab, setActiveTab] = useState('Plants');
    return (
        <div className="min-h-screen p-8 bg-gray-100">
    
            {/* Navigation Tabs */}
            <div className="mb-6 border-b">
                <nav className="-mb-px flex space-x-8">
                    <button
                        onClick={() => setActiveTab('Plants')}
                        className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'Plants'
                            ? 'border-blue-500 text-blue-600'
                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                            }`}
                    >
                        Plants
                    </button>
                    <button
                        onClick={() => setActiveTab('Plant Categories')}
                        className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'Plant Categories'
                            ? 'border-blue-500 text-blue-600'
                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                            }`}
                    >
                        Plant Categories
                    </button>
                    <button
                        onClick={() => setActiveTab('Locations')}
                        className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'Locations'
                            ? 'border-blue-500 text-blue-600'
                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                            }`}
                    >
                        Locations
                    </button>
                </nav>
            </div>
            {/* Active Tab Content */}
            <div>
                {activeTab === 'Plants' && <PlantList />}
                {activeTab === 'Plant Categories' && <PlantCategoryList />}
                {activeTab === 'Locations' && <LocationList />}
            </div>
        </div>
    );
}

export default Admin;
